import {defineStore} from "pinia";
import {useMainStore} from "@/stores/main";
import axios, {AxiosError} from "axios";
import {FormErrors, FormState} from "../../types/withdrawal";

interface RequestStore {
    loading: boolean,
    form: FormState,
    errors: FormErrors | null,
}

export function useRequestStore() {

    const store = defineStore('request', {

        state: (): RequestStore => ({
            loading: false,
            form: {
                full_name: null,
                address: {
                    street: null,
                    city: null,
                    zip: null,
                },
                email: null,
                phone: null,
                order_id: null,
                order_date: null,
                delivery_date: null,
                description: null,
                iban: null,
                return_method: null,
                return_method_description: null,
                is_partial: false,
                items: []
            },
            errors: null,
        }),

        actions: {
            async submit() {
                try {
                    this.loading = true
                    this.errors = null

                    const mainStore = useMainStore()

                    await axios.post('/odstupenie/formular/process', this.form)

                    mainStore.complete = true
                    this.loading = false
                } catch (error) {
                    const axiosError = error as AxiosError<{ errors: FormErrors }>;
                    this.errors = axiosError.response?.data?.errors ?? null;
                    this.loading = false;
                }
            },

            clearError(field: keyof FormErrors) {
                if (this.errors) {
                    this.errors[field] = undefined
                }
            },
        }

    })

    return store()

}
